/**
 * Created by 胜 on 2017/6/11.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';

import LectureCellPro from './LectureCellPro';

class LectureListenTips extends Component {
    constructor() {
        super();
        this.state = {
            initialized: false,
            tips: [],
        };

        this.init = this.init.bind(this);
    }

    componentDidMount() {
        this.init();
    }

    init() {
        const {lectureType, lectureMode, isRelay, channel, imageMode} = this.props;
        let {tips} = this.state;
        let isChannelCostFix = channel && channel.is_cost_fix;

        if (lectureType === 'pay_lecture') {
            tips.push('本次课堂是付费课，购买后即可进入课堂');
        } else if (lectureType === 'password_lecture') {
            tips.push('本次课堂是加密课，输入密码即可进入课堂');
        } else {
            tips.push('本次课堂是免费公开课');
        }

        if (lectureMode === 'video') {
            tips.push('上课方式为录制视频与语音交互模式互动直播');
        } else if (lectureMode === 'audio') {
            tips.push('上课方式为录制音频与语音交互模式互动直播');
        } else if (imageMode === 'ppt') {
            tips.push('上课方式为PPT与语音交互模式互动直播');
        }else {
            tips.push('上课方式为语音+图文消息互动直播');
        }

        tips.push('关注直播间，可以接收下次开课通知');

        if (!isChannelCostFix) {
            tips.push('有时效性的专栏，课程内容仅在购买有效期内可反复收听');
        } else {
            tips.push('本次课程内容永久保存，可反复收听');
        }

        if (!isRelay) {
            tips.push('对课程有疑问可点击下方“课程咨询”留言');
        }

        this.setState({tips: tips, initialized: true});
    }

    render() {
        const {tips, initialized} = this.state;

        if (!initialized) {
            return null;
        }

        return (
            <LectureCellPro>
                {tips.map((item, index) => (
                    <p key={index}> {index + 1}. {item}</p>
                ))}
            </LectureCellPro>
        )
    }
}

export default connect((state) => ({
    lectureType: state.lecture.lecture.lecture_type,
    lectureMode: state.lecture.lecture.lecture_mode,
    channel: state.lecture.channel,
    isRelay: state.lecture.lecture.is_relay,
    imageMode: state.lecture.lecture.image_mode,
}))(LectureListenTips);


// WEBPACK FOOTER //
// ./src/components/lecture/LectureListenTips.js